module.exports = __webpack_public_path__ + "static/small-card-ccc4028a1f6e605ffa9a30c6020946a4.png";